<template>
  <div>
    <div>
      <a-select
        :allow-clear="false"
        :filter-option="false"
        :label-in-value="true"
        :options="options"
        :show-search="true"
        :value="selected"
        @change="change"
        @search="search"
        :style="selected ? { width: 'calc(100% - 66px)' } : {}"
      ></a-select>
      <edit-button
        v-if="selected"
        v-permission="{
          action: 'base.inventory.update',
          effect: 'disabled'
        }"
        @click="$refs.inputDrawer.show(selected.key)"
      ></edit-button>
    </div>
<!--    TODO: 样式丢失-->
    <input-drawer ref="inputDrawer"></input-drawer>
  </div>
</template>

<script>
import { getServiceInventoryList } from '@/api/inventory.js'
import EditButton from '@/components/button/EditButton.vue'
import InputDrawer from '@/views/ServiceInventory/modules/InputDrawer.vue'

export default {
  name: 'ServiceSelect',
  components: {
    InputDrawer,
    EditButton
  },
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      form: {
        name: ''
      },
      selected: undefined,
      options: [],
      total: 0,
      timer: null
    }
  },
  mounted () {
    if (this.value) {
      this.selected = {
        key: this.value.id,
        label: this.value.name
      }
    }
    this.fetch()
  },
  methods: {
    fetch () {
      const params = {}
      if (this.form.name) params.name = this.form.name
      getServiceInventoryList(params).then(res => {
        const data = res.data
        this.total = data.total
        data.data.forEach(role => {
          if (
            this.options.filter(option => option.value === role.id)
              .length === 0
          ) {
            this.options.push({
              key: role.id,
              label: role.name
            })
          }
        })
      })
    },
    change (value) {
      this.$emit('input', {
        id: value.key,
        name: value.label
      })
    },
    search (value) {
      this.form.name = value
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.options = []
        this.fetch()
      }, 500)
    }
  },
  watch: {
    value: {
      handler (v) {
        if (v) {
          this.selected = {
            label: v.name,
            key: v.id
          }
        }
      },
      deep: true
    }
  }
}
</script>
